import { useEffect, useRef, useState } from "react";
import styles from "./LetterOfIntent.module.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { ExpandMoreRounded, Print } from "@mui/icons-material";
import _sendAPIRequest from "../../../../helpers/api";
import { PortalApiUrls } from "../../../../helpers/api-urls/PortalApiUrls";
import { dateTimeFormatter } from "../../../../helpers/formatter";
import ScreenLoader from "../../../../elements/CustomScreeenLoader/ScreenLoader";
import { useReactToPrint } from "react-to-print";

const LetterOfIntent = ({ bidDetails }) => {
  const [expanded, setExpanded] = useState(true);
  const [screenLoader, setScreenLoader] = useState(true);
  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  const [letterOfIntent, setLetterOfIntent] = useState([]);

  const fetchLetterofIntent = async () => {
    try {
      const response = await _sendAPIRequest(
        "GET",
        PortalApiUrls.LIVE_BID_LETTER_OF_INTENT_FOR_BUYER +
          `${bidDetails?.id}/`,
        "",
        true
      );
      if (response.status === 200) {
        setLetterOfIntent(response?.data);
        setScreenLoader(false);
      }
    } catch (error) {
      console.log(error);
      setScreenLoader(false);
    }
  };

  useEffect(() => {
    fetchLetterofIntent();
  }, []);

  const handleAccordionChange = () => {
    setExpanded(!expanded);
  };

  if (screenLoader) {
    return <ScreenLoader />;
  }

  return (
    <>
      <br />
      {letterOfIntent?.length === 0 ? (
        <Box
          sx={{
            minHeight: "40vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            color: "#6b7280",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.1rem",
              fontWeight: 600,
              color: "#374151",
            }}
          >
            No Letter of Intent Generated
          </Typography>

          <Typography
            sx={{
              mt: 1,
              fontSize: "0.9rem",
              color: "#6b7280",
            }}
          >
            All products may be cancelled or not awarded yet
          </Typography>
        </Box>
      ) : (
        <div className={styles["heading"]}>
          <Typography variant="h6">Company Name</Typography>
        </div>
      )}
      {letterOfIntent.map((letter) => {
        return (
          <>
            <Accordion onChange={handleAccordionChange} defaultExpanded={true}>
              <AccordionSummary expandIcon={<ExpandMoreRounded />}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography>{letter?.supplier?.name}</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div ref={contentRef}>
                  <div className={styles["loi-content"]}>
                    <div
                      className={styles["bid-Letter"]}
                      style={{
                        position: "relative",
                        textAlign: "center",
                        paddingRight: "40px", // leave space so text doesn't overlap icon
                      }}
                    >
                      <Typography
                        variant="h6"
                        className={styles["bid-letter-contnet"]}
                        style={{ margin: 0 }}
                      >
                        LETTER OF INTENT FOR BID AWARD
                      </Typography>

                      <button
                        onClick={reactToPrintFn}
                        className={styles["no-print"]}
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        <Print />
                      </button>
                    </div>

                    <br />
                    <Typography>
                      Date: {dateTimeFormatter(letter?.created_at)}
                    </Typography>
                    <Typography>
                      LOI Number: <strong>{letter?.formatted_number}</strong>
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{ marginTop: "20px", mb: 2, fontWeight: "bold" }}
                    >
                      Buyer Information
                    </Typography>
                    <table className={styles["loi-table"]}>
                      <thead>
                        <tr>
                          <th>Company Name</th>
                          <th>Company Email</th>
                          <th>Contact</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td data-label="Company Name">
                            {letter?.buyer?.name}
                          </td>
                          <td data-label="Company Email">
                            {letter?.buyer?.business_email}
                          </td>
                          <td data-label="Contact">
                            {letter?.buyer?.business_mobile}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {letter?.buyer?.address?.length > 0 && (
                      <>
                        <Typography
                          variant="h6"
                          sx={{ marginTop: "20px", mb: 2, fontSize: "large" }}
                        >
                          Buyer Addresses
                        </Typography>
                        <table className={styles["loi-table"]}>
                          <thead>
                            <tr>
                              <th>Address</th>
                              <th>City</th>
                              <th>Country</th>
                              <th>Pincode</th>
                              <th>State</th>
                            </tr>
                          </thead>
                          <tbody>
                            {letter?.buyer?.address?.map((address) => (
                              <tr>
                                <td data-label="Address">{address?.address}</td>
                                <td data-label="City">{address?.city}</td>
                                <td data-label="Country">{address?.country}</td>
                                <td data-label="Pincode">{address?.pincode}</td>
                                <td data-label="State">{address?.state}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    )}

                    <Typography
                      variant="h6"
                      sx={{ marginTop: "20px", mb: 2, fontWeight: "bold" }}
                    >
                      Supplier Information
                    </Typography>
                    <table className={styles["loi-table"]}>
                      <thead>
                        <tr>
                          <th>Company Name</th>
                          <th>Company Email</th>
                          <th>Contact</th>
                          <th>GST No.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td data-label="Company Name">
                            {letter?.supplier?.name}
                          </td>
                          <td data-label="Company Email">
                            {letter?.supplier?.business_email}
                          </td>
                          <td data-label="Contact">
                            {letter?.supplier?.business_mobile}
                          </td>
                          <td data-label="GST No.">
                            {letter?.supplier?.gstin}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {letter?.supplier?.address?.length > 0 && (
                      <>
                        <Typography
                          variant="h6"
                          sx={{
                            marginTop: "20px",
                            mb: 2,
                            fontSize: "large",
                            fontWeight: "bold",
                          }}
                        >
                          Supplier Addresses
                        </Typography>

                        <table className={styles["loi-table"]}>
                          <thead>
                            <tr>
                              <th>Address</th>
                              <th>City</th>
                              <th>Country</th>
                              <th>Pincode</th>
                              <th>State</th>
                            </tr>
                          </thead>
                          <tbody>
                            {letter?.supplier?.address?.map((address) => (
                              <tr>
                                <td data-label="Address">{address?.address}</td>
                                <td data-label="City">
                                  {address?.city !== "undefined"
                                    ? address?.city
                                    : "Not Declared"}
                                </td>
                                <td data-label="Country">{address?.country}</td>
                                <td data-label="Pincode">{address?.pincode}</td>
                                <td data-label="State">
                                  {address?.state !== "undefined"
                                    ? address?.state
                                    : "Not Declared"}
                                </td>
                              </tr>
                            ))}
                            {console.log(letter?.supplier?.address, " LOI")}
                          </tbody>
                        </table>
                      </>
                    )}

                    <Typography>
                      Dear <strong>{letter?.supplier?.name}</strong>, <br />
                      We are pleased to inform you that your company has been
                      selected as the preferred supplier for the following
                      products, following the conclusion of the live bidding
                      process.
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{ marginTop: "20px", mb: 2, fontWeight: "bold" }}
                    >
                      Products
                    </Typography>
                    <table className={styles["loi-table"]}>
                      <thead>
                        <tr>
                          <th>Product Name</th>
                          <th>Quantity</th>
                          <th>Reserved Price</th>
                          <th>Bid Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {letter?.bid_pricing?.map((bidProduct) => (
                          <tr>
                            <td>{bidProduct.product?.title}</td>
                            <td>{bidProduct.product?.quantity}</td>
                            <td>₹ {bidProduct.product?.reserved_price}</td>
                            <td>₹ {bidProduct?.amount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <Typography variant="h6">
                      <strong>Intent Statement:</strong>
                    </Typography>
                    <Typography>
                      This is just a Letter of Intent and is not legally
                      binding. All the key details of the intent will be clearly
                      outlined in this document, and you will also receive an
                      official copy. For the final contract, the buyer will
                      provide the necessary content to proceed.
                    </Typography>
                    <br />
                    <Typography variant="h6">
                      <strong>Next Steps</strong>
                    </Typography>
                    <Typography>
                      We request you to review the attached contract and provide
                      your confirmation by the deadline. Once confirmed, the
                      formal contract will be finalized and executed.
                    </Typography>

                    <Typography>
                      For any modifications or queries, please contact at{" "}
                      {letter?.buyer?.business_email} or{" "}
                      {letter?.buyer?.business_mobile}.
                    </Typography>

                    <Typography variant="h6" sx={{ marginTop: "20px" }}>
                      <strong>Delivery Term </strong>
                    </Typography>
                    <Typography>
                      {letter?.bid?.delivery_terms.replace(/<p>|<\/p>/g, "")}
                    </Typography>

                    <Typography variant="h6" sx={{ marginTop: "20px" }}>
                      <strong>Payment Term</strong>
                    </Typography>
                    <Typography>
                      {letter?.bid?.payment_terms.replace(/<p>|<\/p>/g, "")}
                    </Typography>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </>
        );
      })}
    </>
  );
};

export default LetterOfIntent;
